import { HeaderV2LayoutAction } from "../../../stores/header-v2-layout-store";
import type { HeaderActionsManagerProps, IHeaderActionsManager } from "./header-actions-manager.interface";

export class HeaderActionsManager implements IHeaderActionsManager {
  private _actions?: HeaderV2LayoutAction[] = [];
  private _isMobile: boolean = false;

  constructor({ actions, isMobile }: HeaderActionsManagerProps) {
    this._actions = actions;
    this._isMobile = isMobile;
  }

  public get filteredActions(): HeaderV2LayoutAction[] | undefined {
    return this._actions?.filter((action) => this.filterAction(action));
  }

  private filterAction(action: HeaderV2LayoutAction) {
    const shouldRemoveSearchIconAction = action === HeaderV2LayoutAction.search && !this._isMobile;

    if (shouldRemoveSearchIconAction) {
      return false;
    }

    return true;
  }
}
